import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { getAppMode, getRegionByOrigin } from '@/shared/utils';

interface RegionState {
  regionFias: string | null;
  regionName: string | null;
}

const LS_FIAS = 'region_fias';
const LS_NAME = 'region_name';

/**
 * Регион регионального бота MAX: задан деплоем и перекрывает сохранённый
 * выбор. В PWA и у главного бота — null, работает выбор человека
 */
function botRegion(): RegionState | null {
  if (getAppMode() !== 'max') return null;
  return getRegionByOrigin();
}

function storedRegion(): RegionState {
  return {
    regionFias: localStorage.getItem(LS_FIAS),
    regionName: localStorage.getItem(LS_NAME),
  };
}

// window.__CONFIG__ уже на месте: /config.js подключён в <head> до бандла
const initialState: RegionState = botRegion() ?? storedRegion();

const regionSlice = createSlice({
  name: 'region',
  initialState,
  reducers: {
    setRegion(
      state,
      action: PayloadAction<{ regionFias: string; regionName: string }>
    ) {
      state.regionFias = action.payload.regionFias;
      state.regionName = action.payload.regionName;
      localStorage.setItem(LS_FIAS, action.payload.regionFias);
      localStorage.setItem(LS_NAME, action.payload.regionName);
    },
  },
});

export const { setRegion } = regionSlice.actions;
export default regionSlice.reducer;
